import { findFieldByType } from './findFieldByType';

export function getName(fields) {
  const name = findFieldByType(fields, 'name')?.value;
  const firstName = findFieldByType(fields, 'first-name')?.value;
  const lastName = findFieldByType(fields, 'last-name')?.value;

  return name || [firstName, lastName].filter(Boolean).join(' ');
}
